import { Component, OnDestroy, OnInit } from "@angular/core";
import { EventType, Router } from "@angular/router";
import { cigaroUser } from "./models/user";
import { AuthService } from "./services/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { MenuController, Platform } from "@ionic/angular";
import { Location } from "@angular/common";
import { SmokingprotocolService } from "./services/smokingprotocol.service";
import { Subscription } from "rxjs";
import { AppVersion } from "@awesome-cordova-plugins/app-version/ngx";
//import { setVideoPlayer } from './utils/utils';
import { App } from "@capacitor/app";
import { ConfigService } from "./services/config.service";
import { PageLink } from "./models/page_link";
import { SwUpdate } from "@angular/service-worker";

@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  public appPages: PageLink[] = [];
  private user: cigaroUser | null = null;
  private userSub: Subscription | null = null;
  private sp_countSub: Subscription | null = null;
  private routerSub: Subscription | null = null;
  public AppVersion: string = "1.9.9";
  public showCigarSelector = false;
  public videoLink = "https://www.youtube.com/watch?v=65IREl_5XIM";

  constructor(
    private as: AuthService,
    private router: Router,
    private translate: TranslateService,
    private platform: Platform,
    private location: Location,
    private sps: SmokingprotocolService,
    private appVersion: AppVersion,
    private mc: MenuController,
    private configS: ConfigService,
    private swUpdate: SwUpdate,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.fixUnrecoverable();
    await this.setAppVersion();
    await this.configS.activateLanguage(); //Sprache setzen
    await this.updateNavandCSS(await this.as.getCigaroUser(), true);
    await this.mc.open();
    await this.platform.ready();
    await this.deleteSplash();
    await this.configS.pwaInstallCheck();
    await this.resetCigarSelector();
    //Anzahl der Rauchprotokolle aktuell halten, bei Anlegen/Löschen
    this.sp_countSub = this.sps
      .getSPCountUpdateListener()
      .subscribe(async (spc: number) => {
        if (this.user !== null) {
          this.user.sp_count = spc;
          localStorage.setItem("user", JSON.stringify(this.user));
          //console.log(`anzahl rauchprotokolle: ${spc}`)
          await this.changeLinks(true);
        }
      });
    //if user changes we know it here and change links
    this.userSub = this.as.getUserUpdateListener().subscribe(async (user) => {
      await this.updateNavandCSS(user);
    });
    localStorage.setItem("checkSP", "1"); //Flag für Überprüfung ob SP läuft

    const locale = this.translate.getDefaultLang();
    if (locale === "de") {
      //Videolink für DE ändern
      this.videoLink = "https://www.youtube.com/watch?v=-gFUExuc3mw";
    }

    //BackButton-Click abbonieren und auf letzte Url umleiten
    this.platform.backButton.subscribeWithPriority(1, () => {
      if (
        document.querySelector("app-rauchprotokoll") === null &&
        document.querySelector("app-sp-detail") === null
      ) {
        if (this.router.url === "/folder/login") {
          App.exitApp();
        } else {
          this.location.back();
        }
      }
    });
  }

  /**
   *
   * @param loggedIn
   * @description
   * Methode passt die Links im Folder Menu dem Login-Status an
   *
   */

  private async changeLinks(loggedIn: boolean): Promise<void> {
    this.appPages = [];
    if (loggedIn === true) {
      this.appPages.push({
        title: "burgermenu.profile",
        url: "folder/profile/",
        icon: "person-sharp",
      });
      this.appPages.push({
        title: "burgermenu.logout",
        url: "folder/logout/",
        icon: "log-out-sharp",
      });
      let humname: string = "";
      let iconname: string = "";
      //Einkaufsliste soll nach den richtigen Humidoren gelistet sein
      if (this.user !== null) {
        let sortHumsByType = function (a, b) {
          if (a.isShoppingList < b.isShoppingList) {
            return -1;
          }
          return 0;
        };
        this.user.humidors.sort(sortHumsByType);
        this.user.humidors.forEach((humidor) => {
          if (humidor.isShoppingList != true) {
            /*wichtig Typumwandlung zulassen
        wg. MYSQL Boolean*/
            let humiconsize: string = "small";
            if (humidor.capacity >= 100 && humidor.capacity < 300) {
              humiconsize = "medium";
            } else if (humidor.capacity >= 300 && humidor.capacity < 1000) {
              humiconsize = "large";
            } else if (humidor.capacity >= 1000) {
              humiconsize = "xlarge";
            }
            iconname = "md-humi-" + humiconsize;
            humname = humidor.name;
          } else {
            this.appPages.push({
              title: "burgermenu.uberblick",
              url: "folder/uberblick/",
              icon: "eye",
            });
            iconname = "cart-sharp";
            humname = `burgermenu.${humidor.name}`;
          }
          this.appPages.push({
            title: humname,
            url: "folder/humidor/" + humidor.id,
            icon: iconname,
            capacity: humidor.capacity,
          });
        });
        //Link Rauchprotokolle
        if (
          typeof this.user.sp_count !== "undefined" &&
          this.user.sp_count !== 0
        ) {
          this.appPages.push({
            title: "burgermenu.smoking-protocols",
            url: "folder/rauchprotokoll-liste/",
            icon: "reader-sharp",
            sp_count: this.user.sp_count,
          });
        }
        //Link Raucharchiv
        if (
          typeof this.user.humidor_view.show_archive !== "undefined" &&
          this.user.humidor_view.show_archive == true
        ) {
          this.appPages.push({
            title: "burgermenu.smoking-archive",
            url: "folder/raucharchiv/",
            icon: "cigaro-stats",
          });
        }
        this.appPages.push({
          title: "burgermenu.toplist",
          url: "/folder/toplist",
          icon: "md-lorbeer-cig",
        });
        this.appPages.push({
          title: "burgermenu.help",
          url: "/folder/help",
          icon: "help-circle-sharp",
        });
      }
    } else {
      this.appPages.push({
        title: "burgermenu.demo",
        url: "/folder/demo",
        icon: "videocam-sharp",
      });
      this.appPages.push({
        title: "burgermenu.login",
        url: "/folder/login",
        icon: "log-in-sharp",
      });
      this.appPages.push({
        title: "burgermenu.register",
        url: "/folder/register",
        icon: "person-add-sharp",
      });
    }
    //Diese Links unabhängig vom Login-Status anzeigen

    this.appPages.push({
      title: "burgermenu.privacy",
      url: "/folder/privacy",
      icon: "information-circle-sharp",
    });
    this.appPages.push({
      title: "burgermenu.imprint",
      url: "/folder/imprint",
      icon: "information-circle-sharp",
    });
  }

  /**
   * Ausloggen, Navi aktualisieren
   */
  async logout(): Promise<void> {
    const loggedOut = await this.as.logout();
    if (loggedOut === true) {
      await this.changeLinks(false);
      await this.router.navigate(["folder/login"]);
    }
  }
  /**
   * @param filename
   * @description
   * Farbthemes nachladen
   */
  private async loadCSS(filename: string): Promise<void> {
    // Anderes Theme ggf. entfernen
    var lastTheme: HTMLElement | null = document.getElementById("themeStyle");
    if (lastTheme !== null && lastTheme.innerHTML.indexOf(filename) === -1) {
      console.log(lastTheme.innerHTML);
      console.log(filename);
      document.getElementsByTagName("head")[0].removeChild(lastTheme);
      // Neues Theme einfügen
      var objStyle = document.createElement("style");
      var objText = document.createTextNode(
        "@import url(" + filename + ") screen;",
      );
      objStyle.id = "themeStyle";
      objStyle.appendChild(objText);
      document.getElementsByTagName("head")[0].appendChild(objStyle);
    } else if (lastTheme === null) {
      // Neues Theme einfügen
      var objStyle = document.createElement("style");
      var objText = document.createTextNode(
        "@import url(" + filename + ") screen;",
      );
      objStyle.id = "themeStyle";
      objStyle.appendChild(objText);
      document.getElementsByTagName("head")[0].appendChild(objStyle);
    }
    if (this.platform.is("pwa") && this.platform.is("android")) {
      //Android Special Meta-ThemeColor für Notch
      let newThemeColor = "#53473D";
      switch (filename) {
        case "dark_davy.css":
          newThemeColor = "#413c38";
          break;
        case "romeo.css":
          newThemeColor = "#b32134";
          break;
        case "bones.css":
          newThemeColor = "#15191A";
          break;
        case "burn.css":
          newThemeColor = "#232221";
          break;
        case "dark_clown.css":
          newThemeColor = "#282b24";
          break;
        case "gunmetal.css":
          newThemeColor = "#1E2D35";
          break;
        case "herbert.css":
          newThemeColor = "#ffc448";
          break;
      }
      const themeColor = document.querySelector("[name=theme-color]");
      if (themeColor) themeColor.setAttribute("content", newThemeColor);
    }
  }
  /**
   * @param user
   * @param redirect ?Weiterleiten zum 1sten Humi?
   * @description
   * Aktualisiert Navi und lädt Benutzer Theme nach
   */
  private async updateNavandCSS(
    user: cigaroUser | null,
    redirect: boolean = false,
  ): Promise<void> {
    if (user !== null) {
      this.user = user;
      await this.changeLinks(true);
      await this.loadCSS(`${this.user.theme}.css`);
      //Nur bei Einstieg, wenn Benutzer noch in localStorage
      if (redirect === true && window.document.URL.indexOf("profile") === -1) {
        let link1sthumi: string = "folder/humidor/" + this.user.humidors[0].id;
        this.router.navigate([link1sthumi]);
      }
    } else {
      await this.changeLinks(false);
      await this.loadCSS("cigaro.css");
    }
  }
  /**
   * removes Splashscreen-Image from DOM
   */
  private async deleteSplash(): Promise<void> {
    setTimeout(() => {
      const splash = document.getElementById("splash");
      document.getElementsByTagName("app-root")[0].removeChild(splash);
    }, 1000);
  }
  /**
   * sets AppVersion shown in MainMenu
   */
  private async setAppVersion() {
    try {
      this.AppVersion = await this.appVersion.getVersionNumber();
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * evil hack to reset cigar selector on route change
   */
  private async resetCigarSelector() {
    this.routerSub = this.router.events.subscribe((event) => {
      if (event.type === EventType.NavigationEnd) {
        if (event.url.includes("humidor")) {
          const csReset = document.getElementById("csResetButton");
          if (csReset) {
            csReset.click();
          }
        }
      }
    });
  }

  public getUser() {
    return this.user;
  }

  private async fixUnrecoverable() {
    if (!this.swUpdate.isEnabled) {
      return false;
    }
    this.swUpdate.unrecoverable.subscribe(async (event) => {
      const registrations = await navigator.serviceWorker.getRegistrations();
      console.error("Unrecoverable PWA state:", event);
      for (const registration of registrations) {
        await registration.unregister();
      }

      const cacheNames = await caches.keys();

      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
      }

      window.location.reload();
    });
    await this.swUpdate.checkForUpdate();
  }

  /**
   * @description
   * Destruktor, Observables löschen
   */
  public ngOnDestroy() {
    if (this.userSub !== null) {
      this.userSub.unsubscribe();
    }
    if (this.sp_countSub !== null) {
      this.sp_countSub.unsubscribe();
    }
    if (this.routerSub !== null) {
      this.routerSub.unsubscribe();
    }
  }
}
